import { Student } from '../../shared-components/student/student.model';

export class StudentList {

	// Properties
	ID = -1;
	Name: string;
	Description: string;
	Status = true;
	Access: string;
	Owner: number;
	OwnerFirstName: string;
	OwnerMiddleName: string;
	OwnerLastName: string;
	AddedBy: number;
	AddedOn: Date;
	LastUpBy: number;
	LastUpOn: Date;
	DelBy: number;
	DelOn: Date;
	Type: string;
	SchoolIds: number[] = [];
	Scope: string;
	Students: Student[];

	// Non DTO fields
    Selected = false;
    IsSelectedForMassEmail: boolean;
    MassEmailStudents: any[];
    listStudentsCheckAll: boolean;

	// Methods
	duplicate() {
		const duplicate = new StudentList();
		Object.assign(duplicate, this);
		return duplicate;
	}
}
